import UiElement from '../../../shared/ui-element/ui-element';
import analytics, { events } from '../../../shared/analytics';

class EneyPromoBanner extends UiElement {
  ui = {
    button: '.eney-promo-banner__button',
  };

  onInit() {
    analytics.trackEvent(events.ENEY_BANNER_SHOWN);
  }

  events = {
    'click @ui.button': 'handleButtonClick',
  };

  handleButtonClick() {
    analytics.trackEvent(events.ENEY_BANNER_BUTTON_CLICK);
  }
}

export default EneyPromoBanner;
